// extracted by mini-css-extract-plugin
module.exports = {"blockList":"BlockList_blockList__2K5D3","blockActive":"BlockList_blockActive__uIlPs"};